import * as ACTION from './constants';
import { arrayMerge } from '../../utils';

const initialState = {
  cohortMemberLoading: false,
  companies: [],
  companyCohorts: {},
  companyCohortForm: {},
  companyCohortUpdating: false,
  companyCohortsLoading: false,
  companyCohortsLoadingError: null,
  companyUsers: {},
  companyUsersLoading: false,
  companyUsersLoadingError: null,
  creatingCompanyCohort: false,
  isLoading: false,
  trainersLoading: false,
  wellnessProgramsLoading: false,
};

export default function reducers(state = initialState, action) {
  switch(action.type) {
    case ACTION.COMPANY_BASE:
      return {...initialState};
    case ACTION.LIBRARY_LOADING:
      return {...state,
        isLoading: true
      };
    case ACTION.LIBRARY_LOADED:
      return {...state,
        isLoading: false,
        companies: arrayMerge(state.companies, action.companies),
      };
    case ACTION.USERS_LOADING:
      return {...state,
        companyUsersLoading: true,
        companyUsersLoadingError: null,
      };
    case ACTION.USERS_LOADED:
      return {...state,
        companyUsersLoading: false,
        companyUsersLoadingError: null,
        companyUsers: {
          ...state.companyUsers,
          [action.id]: action.users,
        },
      };
    case ACTION.USERS_LOADING_ERROR:
      return {...state,
        companyUsersLoading: false,
        companyUsersLoadingError: action.error,
        companyUsers: {
          ...state.companyUsers,
          [action.id]: [],
        },
      };
    case ACTION.COHORTS_LOADING:
      return {...state,
        companyCohortsLoading: true,
        companyCohortsLoadingError: null,
      };
    case ACTION.COHORTS_LOADED:
      return {...state,
        companyCohortsLoading: false,
        companyCohortsLoadingError: null,
        companyCohorts: {
          ...state.companyCohorts,
          [action.id]: action.cohorts,
        },
      };
    case ACTION.COHORTS_LOADING_ERROR:
      return {...state,
        companyUsersLoading: false,
        companyUsersLoadingError: action.error,
        companyCohorts: {
          ...state.companyCohorts,
          [action.id]: [],
        },
      };
    case ACTION.CREATING_COHORT:
      return {...state,
        creatingCompanyCohort: true,
      };
    case ACTION.COHORT_CREATED:
      const companyCohorts = state.companyCohorts[action.companyId]
        ? [...state.companyCohorts[action.companyId], action.cohort]
        : [action.cohort];

      return {...state,
        companyCohorts: {
          ...state.companyCohorts,
          [action.companyId]: companyCohorts,
        },
        creatingCompanyCohort: false,
      };
    case ACTION.COHORT_UPDATING:
      return {...state,
        companyCohortUpdating: true,
      };
    case ACTION.COHORT_UPDATED:
      return {...state,
        companyCohortForm: action.data,
        companyCohortUpdating: false,
        companyCohorts: {
          ...state.companyCohorts,
          [action.id]: action.data,
        },
      };
    case ACTION.SET_COHORT_FORM:
      return {...state,
        companyCohortForm: action.data,
      };
    case ACTION.TRAINERS_LOADING:
      return {...state,
        trainersLoading: true,
      };
    case ACTION.TRAINERS_LOADED:
      return {...state,
        trainersLoading: false,
      };
    case ACTION.WELLNESS_PROGRAMS_LOADING:
      return {...state,
        wellnessProgramsLoading: true,
      };
    case ACTION.WELLNESS_PROGRAMS_LOADED:
      return {...state,
        wellnessProgramsLoading: false,
      };
    case ACTION.COHORT_MEMBER_LOADING:
      return {...state,
        cohortMemberLoading: true,
      };
    case ACTION.COHORT_MEMBER_LOADED:
      return {...state,
        cohortMemberLoading: false,
      };
    default:
      return state;
  }
}
